import { createFileRoute } from "@tanstack/react-router";
import SaintGoogle from "@/pages/SaintGoogle";
export const Route = createFileRoute("/saint-google")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        { name: "robots", content: "noindex, follow" },
        {
          title: "SAINT® TMS in Coral Springs, FL | Verified SAINT Provider",
        },
        {
          name: "description",
          content:
            "5-day, fMRI-guided SAINT® TMS for treatment-resistant depression. Verified SAINT Provider in Coral Springs, FL, serving all of Florida and out-of-state.",
        },
        {
          property: "og:title",
          content: "SAINT® TMS in Coral Springs, FL | Verified SAINT Provider",
        },
        {
          property: "og:description",
          content:
            "5-day, fMRI-guided SAINT® TMS for treatment-resistant depression. Verified SAINT Provider in Coral Springs, FL, serving all of Florida and out-of-state.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/saint-google",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/saint-google",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SaintGoogle />;
}
